
export default {
    name: 'historique-acuite-visuelle',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}